import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { Setup } from '../../../models/interfaces/setup.interface'
import { ModalAddTrainingWorkout, ModalCombineData, ModalCombineDataEdit } from './training-workout.reducer'
import { TrainingWorkoutFormattedProps, TrainingWorkoutTypeEnum } from '../../../components/TrainingWorkout'
import { TrainingWorkoutService } from './training-workout.service'
import { TrainingWorkoutInterface } from '../../../models/interfaces/training-workout.interface'

export interface SaveSetup {
  setups: Setup[]
  id: string
  isGrouped?: boolean
}

export const setTrainingWorkout = createAction<TrainingWorkoutFormattedProps[]>('trainingWorkout/setTrainingWorkout')
export const setTrainingWorkoutType = createAction<TrainingWorkoutTypeEnum | null>('trainingWorkout/setTrainingWorkoutType')
export const setReloadTrainingWorkout = createAction('trainingWorkout/setReloadTrainingWorkout')
export const saveSetup = createAction<SaveSetup>('trainingWorkout/saveSetup')

export const showModalCombine = createAction<ModalCombineData | ModalCombineDataEdit>('trainingWorkout/showModalCombine')
export const resetModalCombine = createAction('trainingWorkout/resetModalCombine')

export const showModalAddTrainingWorkout = createAction<ModalAddTrainingWorkout>('trainingWorkout/showModalAddTrainingWorkout')
export const resetModalAddTrainingWorkout = createAction('trainingWorkout/resetModalAddTrainingWorkout')
export const showModalAddSubstitute = createAction<ModalAddTrainingWorkout>('trainingWorkout/showModalAddSubstitute')
export const resetModalAddSubstitute = createAction('trainingWorkout/resetModalAddSubstitute')
export const seletectedTrainingWorkoutData = createAction('trainingWorkout/seletectedTrainingWorkoutData')

export const addTrainingWorkout = createAsyncThunk(
  'trainingWorkout/addTrainingWorkout',
  TrainingWorkoutService.addTrainingWorkout
)

export const removeTrainingWorkoutFromGroup = createAsyncThunk(
  'trainingWorkout/removeTrainingWorkoutFromGroup',
  TrainingWorkoutService.removeTrainingWorkoutFromGroup
)
export const updateSetupTrainingWorkout = createAsyncThunk(
  'trainingWorkout/updateSetupTrainingWorkout',
  TrainingWorkoutService.updateSetupTrainingWorkout
)
export const combineTrainingWorkout = createAsyncThunk(
  'trainingWorkout/combineTrainingWorkout',
  TrainingWorkoutService.combineTrainingWorkout
)
export const updateSetupGroupTrainingWorkout = createAsyncThunk(
  'trainingWorkout/updateSetupGroupTrainingWorkout',
  TrainingWorkoutService.updateSetupGroupTrainingWorkout
)
export const reorderGroupTrainingWorkout = createAsyncThunk(
  'trainingWorkout/reorderGroupTrainingWorkout',
  TrainingWorkoutService.reorderGroupTrainingWorkout
)
export const reorderTrainingWorkout = createAsyncThunk(
  'trainingWorkout/reorderTrainingWorkout',
  TrainingWorkoutService.reorderTrainingWorkout
)
export const addTrainingWorkoutInGroup = createAsyncThunk(
  'trainingWorkout/addTrainingWorkoutInGroup',
  TrainingWorkoutService.addTrainingWorkoutInGroup
)
export const getTrainingWorkoutList = createAsyncThunk(
  'trainingWorkout/getTrainingWorkoutList',
  TrainingWorkoutService.getTrainingWorkoutList
)
export const updateTypeGroupTrainingWorkout = createAsyncThunk(
  'trainingWorkout/updateTypeGroupTrainingWorkout',
  TrainingWorkoutService.updateTypeGroupTrainingWorkout
)

export interface AddSubstituteToParentPayload {
  parentId: string
  substitute: TrainingWorkoutInterface
}

export interface RemoveSubstituteFromParentPayload {
  parentId: string
  substituteId: string
}

export interface UpdateSubstituteSetupPayload {
  parentId: string
  substituteId: string
  setup: Setup[]
}

export const addSubstituteToParent = createAction<AddSubstituteToParentPayload>(
  'trainingWorkout/addSubstituteToParent'
)
export const removeSubstituteFromParent = createAction<RemoveSubstituteFromParentPayload>(
  'trainingWorkout/removeSubstituteFromParent'
)
export const updateSubstituteSetupInState = createAction<UpdateSubstituteSetupPayload>(
  'trainingWorkout/updateSubstituteSetupInState'
)

export const addSubstituteTrainingWorkout = createAsyncThunk(
  'trainingWorkout/addSubstituteTrainingWorkout',
  TrainingWorkoutService.addSubstituteTrainingWorkout
)
export const removeSubstituteTrainingWorkout = createAsyncThunk(
  'trainingWorkout/removeSubstituteTrainingWorkout',
  TrainingWorkoutService.removeSubstituteTrainingWorkout
)
export const updateSubstituteSetup = createAsyncThunk(
  'trainingWorkout/updateSubstituteSetup',
  TrainingWorkoutService.updateSubstituteSetup
)
